import actions from './actions';

// Regla del módulo (anti-patrón conocido, ver redux/invoice/): iniciar un loading
// NUNCA vacía el arreglo de resultados. Si se vacía, la tabla se desmonta junto
// con su spinner y el empty-state aparece mientras todavía se está cargando.
// El empty-state se condiciona en el componente a `!loading && items.length === 0`.
const initialState = {
    // Previsualización del archivo: { requiereMapeo, mapeo, columnas, muestra, filasCrudas, filas, descartadas, aviso }
    preview: null,
    loadingPreview: false,
    loadingMapeo: false,

    // Una entrada por fila del banco: { indice, fila, candidatos[] }
    resultados: [],
    ventanaDias: null,
    loadingSugerencias: false,

    // Confirmaciones de esta sesión: { [indiceFilaBanco]: { registroId, referenciaBancaria, candidato } }
    confirmados: {},
    // Clave `${indice}-${registroId}` del botón que está confirmando/revirtiendo
    procesando: null,

    loadingCarga: false,
    cargaRegistrada: null,

    cargas: [],
    cargasPagination: {},
    loadingCargas: false,
};

export default function conciliacionBancariaReducer(state = initialState, action) {
    switch (action.type) {
        case actions.CONC_PREVISUALIZAR_REQUEST:
            return { ...state, loadingPreview: true };
        case actions.CONC_PREVISUALIZAR_SUCCESS:
            // Archivo nuevo o re-mapeado: las sugerencias y confirmaciones anteriores ya no aplican
            return {
                ...state,
                loadingPreview: false,
                preview: action.payload,
                resultados: [],
                confirmados: {},
                cargaRegistrada: null,
            };
        case actions.CONC_PREVISUALIZAR_ERROR:
            return { ...state, loadingPreview: false };

        case actions.CONC_GUARDAR_MAPEO_REQUEST:
            return { ...state, loadingMapeo: true };
        case actions.CONC_GUARDAR_MAPEO_SUCCESS:
        case actions.CONC_GUARDAR_MAPEO_ERROR:
            return { ...state, loadingMapeo: false };

        case actions.CONC_SUGERENCIAS_REQUEST:
            return { ...state, loadingSugerencias: true };
        case actions.CONC_SUGERENCIAS_SUCCESS:
            return {
                ...state,
                loadingSugerencias: false,
                resultados: action.payload.resultados,
                ventanaDias: action.payload.ventanaDias,
                confirmados: {},
            };
        case actions.CONC_SUGERENCIAS_ERROR:
            return { ...state, loadingSugerencias: false };

        case actions.CONC_CONFIRMAR_REQUEST:
            return { ...state, procesando: `${action.indice}-${action.candidato._id}` };
        case actions.CONC_CONFIRMAR_SUCCESS:
            return {
                ...state,
                procesando: null,
                confirmados: { ...state.confirmados, [action.payload.indice]: action.payload.confirmacion },
            };
        case actions.CONC_CONFIRMAR_ERROR:
            return { ...state, procesando: null };

        case actions.CONC_DESCONCILIAR_REQUEST:
            return { ...state, procesando: `${action.indice}-${action.registroId}` };
        case actions.CONC_DESCONCILIAR_SUCCESS: {
            const confirmados = { ...state.confirmados };
            delete confirmados[action.payload.indice];
            return { ...state, procesando: null, confirmados };
        }
        case actions.CONC_DESCONCILIAR_ERROR:
            return { ...state, procesando: null };

        case actions.CONC_REGISTRAR_CARGA_REQUEST:
            return { ...state, loadingCarga: true };
        case actions.CONC_REGISTRAR_CARGA_SUCCESS:
            return { ...state, loadingCarga: false, cargaRegistrada: action.payload };
        case actions.CONC_REGISTRAR_CARGA_ERROR:
            return { ...state, loadingCarga: false };

        case actions.CONC_GET_CARGAS_REQUEST:
            return { ...state, loadingCargas: true };
        case actions.CONC_GET_CARGAS_SUCCESS:
            return {
                ...state,
                loadingCargas: false,
                cargas: action.payload.cargas,
                cargasPagination: action.payload.paginationInfo || {},
            };
        case actions.CONC_GET_CARGAS_ERROR:
            return { ...state, loadingCargas: false };

        case actions.CONC_RESET_SESION:
            // El histórico de cargas no es parte de la sesión de conciliación
            return {
                ...initialState,
                cargas: state.cargas,
                cargasPagination: state.cargasPagination,
            };

        default:
            return state;
    }
}
